<div class="display">
<table class="table default-borderless d-flex">
    <tbody class="w-100">
        <tr>
        <td class="left">{{'Dashboard_OD0057' | translate}}:</td>
        <td class="right">{{ClientName}}</td>  
        </tr>

        <tr>
        <td class="left">{{'Dashboard_OD0058' | translate}}:</td>
        <td class="right">{{ClientNo}}</td>
        </tr>
        <tr  *ngIf="isFormSelected" >
            <td class="left">{{'Declaration_affaires_OD0081' | translate}}:</td>
            <td class="branch-styles float-right" style="margin-left:10px" *ngFor="let item of BranchNo">{{item.NrBranche}}/{{item.NoContrat}}</td>
        </tr>
        <tr> 
            <td class="left">{{'Dashboard_OD0059' | translate}}:</td>
            <td class="right">{{Year}}</td> 
            <td width="10%"></td>
            <td *ngIf="isFormSelected"><span class="white ml-2"> {{'Declaration_affaires_OD0083' | translate}}</span> <span class="right mx-1"> {{FromDate}}</span> <span class="white ml-1">{{'Declaration_affaires_OD0084' | translate}}</span> <span class="right ml-1"> {{ToDate}}</span></td>
            </tr>
    </tbody>
</table>
</div>

